<template>
    <EditDialog :show="visible" :title="title">
        <el-form size="mini" ref="form" :model="form" label-width="80px" :rules="rules">
            <el-form-item label="用户账号" prop="UserCode">
                <el-input v-model="form.UserCode"></el-input>
            </el-form-item>
            <el-form-item label="用户名称" prop="UserName">
                <el-input v-model="form.UserName"></el-input>
            </el-form-item>
            <el-form-item label="用户邮箱" prop="Email">
                <el-input v-model="form.Email"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="Phone">
                <el-input v-model="form.Phone"></el-input>
            </el-form-item>
            <el-form-item label="用户角色" prop="RoleID">
                <el-select v-model="form.RoleID" style="width: 100%">
                    <el-option v-for="item in roleList" :key="item.RoleID" :label="item.RoleName" :value="item.RoleID"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属实体" prop="EntityID">
                <TreeSelect
                    node-key="EntityID"
                    label-name="EntityName"
                    :disabled="editModel"
                    :tree-data="entityList"
                    :node-id="pId"
                    @select="handleSelect"
                ></TreeSelect>
            </el-form-item>
        </el-form>
        <template #button>
            <div class="dialog-footer">
                <el-button size="mini" @click="handleSave" style="margin-right: 30px" type="primary">保存</el-button>
                <el-button size="mini" @click="handleCancel">取消</el-button>
            </div>
        </template>
    </EditDialog>
</template>

<script>
import { validateEmail } from "../../../scripts/validator";

export default {
    name: "UserEdit",
    props: {
        visible: {
            type: Boolean,
        },
        editModel: {
            type: Object,
        },
    },
    computed: {
        title() {
            if (this.editModel) {
                return "编辑用户";
            }
            return "新增用户";
        },
    },
    data() {
        return {
            pId: "",
            roleList: [],
            entityList: [],
            form: {
                UserCode: "",
                UserName: "",
                Phone: "",
                Email: "",
                RoleID: "",
                EntityID: "",
                UserID: null,
            },
            rules: {
                UserCode: [{ required: true, message: "必填项", trigger: "blur" }],
                UserName: [{ required: true, message: "必填项", trigger: "blur" }],
                Email: [{ validator: validateEmail, trigger: "blur" }],
                RoleID: [{ required: true, message: "必填项", trigger: "change" }],
                EntityID: [{ required: true, message: "必填项", trigger: "change" }],
            },
        };
    },
    methods: {
        getEntityTree() {
            this.$ajax.post("/Entity/GetEntitySelectTree").then((result) => {
                if (result.Data) {
                    this.entityList = [...result.Data];
                    if (this.editModel) {
                        this.form = { ...this.editModel };
                        this.pId = this.form.EntityID;
                    }
                }
            });
        },
        handleSelect(node) {
            this.form.EntityID = node.EntityID;
            this.form.EntityName = node.EntityName;
        },
        getRole() {
            this.$ajax.post("SysMgr/GetRoleList", { Key: "", PageIndex: 1, PageSize: 2000 }).then((res) => {
                this.roleList = res.Data;
            });
        },
        handleSave() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    if (this.editModel) {
                        this.$ajax.post("/SysMgr/ChangeUser", this.form).then((res) => {
                            this.$success("操作成功");
                            this.$emit("refresh", true);
                            this.handleCancel();
                        });
                    } else {
                        this.$ajax.post("/SysMgr/AddUser", this.form).then((res) => {
                            this.$success("操作成功");
                            this.$emit("refresh", true);
                            this.handleCancel();
                        });
                    }
                }
            });
        },
        handleCancel() {
            this.$emit("update:visible", false);
        },
    },
    created() {
        this.getEntityTree();
        this.getRole();
    },
};
</script>

<style scoped></style>
